package com.evoapps.evoshift.domain.util

import kotlinx.datetime.LocalTime

fun String.normalizeTime(): String {
    val trimmed = this.trim()
    return if (trimmed.length == 4 && trimmed[1] == ':') {
        "0$trimmed"
    } else {
        trimmed
    }
}

fun LocalTime.Companion.parseSafe(timeStr: String): LocalTime {
    return parse(timeStr.normalizeTime())
}

fun calculateDurationHours(start: String, end: String): Double = calculateDurationMinutes(start, end) / 60.0

/**
 * Minutes from [start] to [end] ("HH:mm" or ISO "2024-01-01THH:mm:ss"); an end before the start
 * is the next day (22:00–06:00 is 480). Equal or unreadable times are 0.
 */
fun calculateDurationMinutes(start: String, end: String): Int {
    return try {
        val startTimePart =
            if (start.contains('T')) start.substringAfter('T').take(5) else start.take(5)
        val endTimePart = if (end.contains('T')) end.substringAfter('T').take(5) else end.take(5)

        val (startH, startM) = startTimePart.split(":").map { it.trim().toInt() }
        val (endH, endM) = endTimePart.split(":").map { it.trim().toInt() }

        val startMinutes = startH * 60 + startM
        val endMinutes = endH * 60 + endM

        if (endMinutes < startMinutes) (endMinutes + 24 * 60) - startMinutes else endMinutes - startMinutes
    } catch (e: Exception) {
        0
    }
}
